import ReadOnlyService from '../base/ReadOnlyService';

class Asset extends ReadOnlyService {
  constructor() {
    super('assets');
  }
}

export default new Asset();
